import {withARC} from 'react-arc'
import config from "../labsConfig";
import {Container} from "../../container/CollectionContainer";


export default withARC(config)(Container)